import React from "react";
import ProgressIcon from "../../../icons/ProgressIcon.svg"

const ProgressBar = ({ earned = 1000, target = 8000 }) => {
  const pct = Math.min(100, Math.max(0, (earned / target) * 100));

  return (
    <div className="w-full h-20 bg-gradient-to-r from-sky-100 to-sky-500 rounded-2xl relative overflow-visible flex items-center">
      {/* Progress Icon (half inside, half outside on the left boundary) */}
      <div className="absolute top-1/2 -translate-y-1/2 left-[40px] -translate-x-1/2">
        <div className="w-24 h-24 bg-black rounded-full flex items-center justify-center">
          <img src={ProgressIcon} alt="Progress" className="w-12 h-12" />
        </div>
      </div>

      {/* Track */}
      <div className="absolute bottom-[20.4px] left-[120px] right-[54px] h-[6px] bg-black rounded-[5px] overflow-hidden">
        <div
          className="h-full bg-white rounded-[5px] transition-all duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>

      {/* Score Display (aligned so its center = track center) */}
      <div
        className="absolute left-1/2 -translate-x-1/2 
                   w-[130px] h-[20px] flex items-center justify-center"
        style={{ bottom: `calc(20.4px + 3px + 7px)` }} // track bottom + half track + offset
      >
        <div className="flex items-baseline space-x-1">
          <span className="text-white text-xl font-medium font-['Inter']">
            {earned}
          </span>
          <span className="text-black text-xl font-medium font-['Inter']">
            /{target}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
